<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        stroke-width=".2"
        d="M19.2 19.3h.1V4.7H4.7v14.6h14.5ZM4.8 3.1h14.4a1.7 1.7 0 0 1 1.7 1.7v14.4a1.7 1.7 0 0 1-1.7 1.7H4.8a1.7 1.7 0 0 1-1.7-1.7V4.8a1.7 1.7 0 0 1 1.7-1.7Z"
      />
      <path
        fill="inherit"
        stroke="none"
        d="M15.25 11.57a.5.5 0 0 1 0 .86l-4.5 2.6a.5.5 0 0 1-.75-.43V9.4a.5.5 0 0 1 .75-.43l4.5 2.6Z"
      />
    </svg>
  </span>
</template>
